$(document).ready(function () {

  const $mainSection = $('.main-section');
  const $nremtSection = $('.nremt-intro-section');

  $(window).on('scroll', function () {
      const heroBottom = $nremtSection.offset().top + $nremtSection.outerHeight();

      if ($(window).scrollTop() >= heroBottom) {
          $mainSection.addClass('fixed');
      } else {
          $mainSection.removeClass('fixed');
      }
  });

  const $socialShare = $('#social-share');
  if (!$socialShare.length) {
      console.error('[Social Share] Container #social-share not found in DOM');
      return;
  }

  const shareURL = $('link[rel="canonical"]').attr('href') ||
      $('meta[property="og:url"]').attr('content') ||
      window.location.origin + window.location.pathname;

  const shareTitle = $('meta[property="og:title"]').attr('content') ||
      $('title').text() ||
      document.title;

  const rawImage = $('.page-image').attr('src') || '';
  const shareImage = shareURL + rawImage;

  const cleanTitle = shareTitle.replace(/\s+/g, ' ').trim();

  const variables = {
      '{{shareURL}}': encodeURIComponent(shareURL),
      '{{shareTitle}}': encodeURIComponent(cleanTitle),
      '{{shareImage}}': encodeURIComponent(shareImage)
  };

  console.log('[Social Share] shareURL:', shareURL);
  console.log('[Social Share] shareTitle:', cleanTitle);
  console.log('[Social Share] shareImage:', shareImage);
  console.log('[Social Share] variables:', variables);

  function replacePlaceholders($el) {
      if (!$el || !$el.length) return;
      $el.find('.social-share-btn:not(.social-share-copy)').each(function () {
          let href = decodeURIComponent($(this).attr('href'));
          $.each(variables, function (placeholder, value) {
              href = href.replace(new RegExp(placeholder.replace(/[{}]/g, '\\$&'), 'g'), value);
          });
          $(this).attr('href', href);
      });
  }

  function wireCopyButton($btn) {
      if (!$btn || !$btn.length) return;
      $btn.on('click', function (e) {
          e.preventDefault();
          if (navigator.clipboard && window.isSecureContext) {
              navigator.clipboard.writeText(shareURL).then(() => {
                  showCopyFeedback('Link copied!', $btn);
              }); fallbackCopyTextToClipboard(shareURL, $btn);
             
          } 
      });
  }

  replacePlaceholders($socialShare);
  wireCopyButton($socialShare.find('.social-share-copy'));

  function fallbackCopyTextToClipboard(text, $btn) {
      const $textArea = $('<textarea>').val(text).css({
          top: '0',
          left: '0',
          position: 'fixed'
      });
      $('body').append($textArea);
      $textArea.focus().select();
      try {
          const successful = document.execCommand('copy');
          showCopyFeedback(successful ? 'Link copied!' : 'Failed to copy', $btn);
      } catch (err) {
          showCopyFeedback('Failed to copy', $btn);
      }
      $textArea.remove();
  }

  function showCopyFeedback(message, $anchorElement) {
      $anchorElement.find('.copy-notification').remove();

      const $notification = $('<div>').addClass('copy-notification').text(message).css({
          position: 'absolute',
          top: '50%',
          left: '100%',
          transform: 'translateY(-50%) translateX(8px)',
          background: '#333',
          color: 'white',
          padding: '6px 10px',
          borderRadius: '4px',
          zIndex: 1000,
          fontSize: '11px',
          fontFamily: "'Poppins', sans-serif",
          fontWeight: '600',
          whiteSpace: 'nowrap',
          pointerEvents: 'none',
          opacity: 0,
          transition: 'all 0.3s ease',
          boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
      });

      const $arrow = $('<div>').css({
          position: 'absolute',
          top: '50%',
          right: '100%',
          transform: 'translateY(-50%)',
          width: 0,
          height: 0,
          borderTop: '4px solid transparent',
          borderBottom: '4px solid transparent',
          borderRight: '4px solid #333'
      });

      $notification.append($arrow);
      $anchorElement.append($notification);

      setTimeout(() => {
          $notification.css({
              opacity: 1,
              transform: 'translateY(-50%) translateX(8px)'
          });
      }, 10);

      setTimeout(() => {
          if ($notification.parent().length) {
              $notification.css({
                  opacity: 0,
                  transform: 'translateY(-50%) translateX(15px)'
              });
              setTimeout(() => {
                  if ($notification.parent().length) $notification.remove();
              }, 300);
          }
      }, 2500);
  }
});
 